import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5d13ba1e")

_pushScopeId("data-v-5d13ba1e")
const _hoisted_1 = /*#__PURE__*/_createVNode("a", { style: {"color":"#fff","text-decoration":"none"} }, "安装包下载", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("删除数据")
const _hoisted_3 = { class: "corePerformance_app" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "flex_bt" }, [
  /*#__PURE__*/_createVNode("h6", { style: {"display":"flex","align-items":"center"} }, [
    /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
    /*#__PURE__*/_createVNode("span", null, "进程趋势图")
  ])
], -1)
const _hoisted_5 = {
  class: "spacName visit-record1",
  style: {"width":"100%"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Percent")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Percent")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("cost")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("cost")
const _hoisted_10 = {
  class: "FPStrend",
  style: {"width":"100%","height":"350px"}
}
const _hoisted_11 = { class: "labelStyle" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", {
  style: {"width":"100%","height":"350px"},
  id: "course"
}, null, -1)
const _hoisted_13 = { class: "flex_bt" }
const _hoisted_14 = /*#__PURE__*/_createVNode("h6", { style: {"display":"flex","align-items":"center"} }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createVNode("span", null, "进程数据详情")
], -1)
const _hoisted_15 = { style: {"width":"180px"} }
const _hoisted_16 = {
  class: "spacName",
  style: {"display":"flex","justify-content":"flex-end"}
}
const _hoisted_17 = { class: "corePerformance_app" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "flex_bt" }, [
  /*#__PURE__*/_createVNode("h6", { style: {"display":"flex","align-items":"center"} }, [
    /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
    /*#__PURE__*/_createVNode("span", null, "线程趋势图")
  ])
], -1)
const _hoisted_19 = {
  class: "spacName visit-record1",
  style: {"width":"100%"}
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Percent")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Percent")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("cost")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("cost")
const _hoisted_24 = {
  class: "FPStrend",
  style: {"width":"100%","height":"350px"}
}
const _hoisted_25 = { class: "labelStyle" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", {
  style: {"width":"100%","height":"350px"},
  id: "thread"
}, null, -1)
const _hoisted_27 = { class: "flex_bt" }
const _hoisted_28 = /*#__PURE__*/_createVNode("h6", { style: {"display":"flex","align-items":"center"} }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createVNode("span", null, "线程数据详情")
], -1)
const _hoisted_29 = { style: {"width":"180px"} }
const _hoisted_30 = {
  class: "spacName",
  style: {"display":"flex","justify-content":"flex-end"}
}
const _hoisted_31 = { class: "corePerformance_app" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "flex_bt" }, [
  /*#__PURE__*/_createVNode("h6", { style: {"display":"flex","align-items":"center"} }, [
    /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
    /*#__PURE__*/_createVNode("span", null, "进程数据对比")
  ])
], -1)
const _hoisted_33 = {
  class: "spacName visit-record1",
  style: {"width":"100%"}
}
const _hoisted_34 = /*#__PURE__*/_createTextVNode("开始对比")
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "flex_bt" }, [
  /*#__PURE__*/_createVNode("h6", { style: {"display":"flex","align-items":"center"} }, [
    /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
    /*#__PURE__*/_createVNode("span", null, "进程数据对比详情")
  ])
], -1)
const _hoisted_36 = {
  class: "spacName",
  style: {"display":"flex","justify-content":"flex-end"}
}
const _hoisted_37 = { class: "corePerformance_app" }
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "flex_bt" }, [
  /*#__PURE__*/_createVNode("h6", { style: {"display":"flex","align-items":"center"} }, [
    /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
    /*#__PURE__*/_createVNode("span", null, "线程数据对比")
  ])
], -1)
const _hoisted_39 = {
  class: "spacName visit-record1",
  style: {"width":"100%"}
}
const _hoisted_40 = /*#__PURE__*/_createTextVNode("开始对比")
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "flex_bt" }, [
  /*#__PURE__*/_createVNode("h6", { style: {"display":"flex","align-items":"center"} }, [
    /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
    /*#__PURE__*/_createVNode("span", null, "线程数据对比详情")
  ])
], -1)
const _hoisted_42 = {
  class: "spacName",
  style: {"display":"flex","justify-content":"flex-end"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode(_component_el_card, { class: "tableMinH" }, {
                default: _withId(() => [
                  _createVNode(_component_el_form, {
                    class: "spacForm",
                    size: "mini",
                    model: _ctx.filterList,
                    inline: true
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "日期" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.allOption(['device', 'scene', 'subtype', 'log']))),
                            modelValue: _ctx.filterList.date,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterList.date = $event))
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.date,
                                  label: item.date,
                                  value: item.date
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "机型  " }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.allOption(['scene', 'subtype', 'log']))),
                            modelValue: _ctx.filterList.device,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filterList.device = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deviceOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.device_id,
                                  label: item.name,
                                  value: item.device_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "场景" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.allOption(['subtype', 'log']))),
                            modelValue: _ctx.filterList.scene,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filterList.scene = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sceneOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.chinese,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "测试子类型" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.allOption(['log']))),
                            modelValue: _ctx.filterList.subtype,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.filterList.subtype = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subtypeOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.subtype,
                                  label: item.chinese,
                                  value: item.subtype
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "fileWidth",
                        label: "安卓线性能"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.allOption([]))),
                            modelValue: _ctx.filterList.Journa,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.filterList.Journa = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.JournaOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id_test,
                                  label: item.time,
                                  value: item.id_test
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (_ctx.androidZip != '')
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                            default: _withId(() => [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                size: "mini",
                                style: {"height":"28px"}
                              }, {
                                default: _withId(() => [
                                  _createVNode("a", {
                                    style: {"color":"#fff","text-decoration":"none"},
                                    href: _ctx.androidZip,
                                    download: ""
                                  }, "下载数据", 8, ["href"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            onClick: _ctx.packageBtn,
                            type: "primary",
                            size: "mini",
                            style: {"height":"28px"}
                          }, {
                            default: _withId(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "mini",
                            style: {"height":"28px"},
                            onClick: _ctx.deleteBtn
                          }, {
                            default: _withId(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"]),
                  _createVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createVNode("div", _hoisted_5, [
                      _createVNode(_component_el_form, {
                        class: "spacForm",
                        size: "mini",
                        model: _ctx.filterList,
                        inline: true
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "进程" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.filterList.course,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.filterList.course = $event)),
                                filterable: "",
                                multiple: "",
                                "collapse-tags": "",
                                onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.detailChange('course'))),
                                placeholder: "Select",
                                style: {"width":"240px"}
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.courseOptins, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.name,
                                      value: item.name
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "日期",
                            class: "ms-2"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.filterList.dateRange,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.filterList.dateRange = $event)),
                                type: "daterange",
                                "range-separator": "To",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                size: "mini",
                                format: "YYYY-MM-DD",
                                "value-format": "YYYY-MM-DD",
                                onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.detailChange('course')))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"]),
                      _createVNode(_component_el_form, {
                        class: "spacForm",
                        size: "mini",
                        model: _ctx.filterList,
                        inline: true
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, null, {
                            default: _withId(() => [
                              (_ctx.percent)
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 0,
                                    type: "primary",
                                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.courseBtn()))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_6
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_el_button, {
                                    key: 1,
                                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.courseBtn()))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_7
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, null, {
                            default: _withId(() => [
                              (_ctx.percent)
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 0,
                                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.courseBtn()))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_8
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_el_button, {
                                    key: 1,
                                    type: "primary",
                                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.courseBtn()))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_9
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"]),
                      _createVNode("div", _hoisted_10, [
                        _withDirectives(_createVNode(_component_el_card, null, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_11, _toDisplayString(_ctx.lightPerfTrend.device_name), 1),
                            _hoisted_12
                          ]),
                          _: 1
                        }, 512), [
                          [_directive_loading, _ctx.courseTrendLoading]
                        ])
                      ]),
                      _createVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createVNode("div", _hoisted_15, [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.course_input,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.course_input = $event)),
                            onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.recordSearch('course_input'))),
                            placeholder: "搜索",
                            "prefix-icon": "el-icon-search",
                            size: "mini"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _withDirectives(_createVNode(_component_el_table, {
                        class: "spacName",
                        data: _ctx.courseTable.results,
                        border: "",
                        "header-cell-style": {
                  background: '#f5f7fa',
                }
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "id_row",
                            label: "Id",
                            width: "200",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "name",
                            label: "Name",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "percent",
                            label: "Percentage",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "cost",
                            label: "Cost(ms)",
                            align: "center"
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]), [
                        [_directive_loading, _ctx.courseTableLoading]
                      ]),
                      _createVNode("div", _hoisted_16, [
                        _createVNode(_component_el_form, {
                          style: {"display":"flex","align-items":"center"},
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "每页"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.courseSize,
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.courseSize = $event)),
                                  style: {"width":"55px","height":"28px"},
                                  onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onSearch('course')))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "条记录"
                            }),
                            _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                              default: _withId(() => [
                                _createVNode(_component_el_pagination, {
                                  style: {"text-align":"right"},
                                  currentPage: _ctx.courseCurrentPage,
                                  "onUpdate:currentPage": _cache[23] || (_cache[23] = ($event: any) => (_ctx.courseCurrentPage = $event)),
                                  "page-size": _ctx.courseSize,
                                  total: _ctx.courseTable?.count,
                                  layout: "total, prev, pager, next,jumper",
                                  onCurrentChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.handleCurrentChange('course')))
                                }, null, 8, ["currentPage", "page-size", "total"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode("div", _hoisted_19, [
                      _createVNode(_component_el_form, {
                        class: "spacForm",
                        size: "mini",
                        model: _ctx.filterList,
                        inline: true
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "线程" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.detailChange('thread'))),
                                modelValue: _ctx.filterList.thread,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.filterList.thread = $event)),
                                filterable: "",
                                multiple: "",
                                "collapse-tags": "",
                                placeholder: "Select",
                                style: {"width":"240px"}
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.threadOptins, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.name,
                                      value: item.name
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "日期",
                            class: "ms-2"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.filterList.threadDateRange,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.filterList.threadDateRange = $event)),
                                type: "daterange",
                                "range-separator": "To",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                size: "mini",
                                format: "YYYY-MM-DD",
                                "value-format": "YYYY-MM-DD",
                                onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.detailChange('thread')))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"]),
                      _createVNode(_component_el_form, {
                        class: "spacForm",
                        size: "mini",
                        model: _ctx.filterList,
                        inline: true
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, null, {
                            default: _withId(() => [
                              (_ctx.percent1)
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 0,
                                    type: "primary",
                                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.threadBtn()))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_20
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_el_button, {
                                    key: 1,
                                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.threadBtn()))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_21
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, null, {
                            default: _withId(() => [
                              (_ctx.percent1)
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 0,
                                    onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.threadBtn()))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_22
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_el_button, {
                                    key: 1,
                                    type: "primary",
                                    onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.threadBtn()))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_23
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"]),
                      _createVNode("div", _hoisted_24, [
                        _withDirectives(_createVNode(_component_el_card, null, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_25, _toDisplayString(_ctx.lightPerfTrend.device_name), 1),
                            _hoisted_26
                          ]),
                          _: 1
                        }, 512), [
                          [_directive_loading, _ctx.threadTrendLoading]
                        ])
                      ]),
                      _createVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createVNode("div", _hoisted_29, [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.thread_input,
                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.thread_input = $event)),
                            onChange: _cache[34] || (_cache[34] = ($event: any) => (_ctx.recordSearch('thread_input'))),
                            placeholder: "搜索",
                            "prefix-icon": "el-icon-search",
                            size: "mini"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _withDirectives(_createVNode(_component_el_table, {
                        class: "spacName",
                        data: _ctx.threadTable.results,
                        border: "",
                        "header-cell-style": {
                  background: '#f5f7fa',
                }
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "id_row",
                            label: "Id",
                            width: "200",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "name",
                            label: "Name",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "percent",
                            label: "Percentage",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "cost",
                            label: "Cost(ms)",
                            align: "center"
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]), [
                        [_directive_loading, _ctx.threadTabelLoading]
                      ]),
                      _createVNode("div", _hoisted_30, [
                        _createVNode(_component_el_form, {
                          style: {"display":"flex","align-items":"center"},
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "每页"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.threadSize,
                                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.threadSize = $event)),
                                  style: {"width":"55px","height":"28px"},
                                  onChange: _cache[36] || (_cache[36] = ($event: any) => (_ctx.onSearch('thread')))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "条记录"
                            }),
                            _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                              default: _withId(() => [
                                _createVNode(_component_el_pagination, {
                                  style: {"text-align":"right"},
                                  currentPage: _ctx.threadCurrentPage,
                                  "onUpdate:currentPage": _cache[37] || (_cache[37] = ($event: any) => (_ctx.threadCurrentPage = $event)),
                                  "page-size": _ctx.threadSize,
                                  total: _ctx.threadTable?.count,
                                  layout: "total, prev, pager, next,jumper",
                                  onCurrentChange: _cache[38] || (_cache[38] = ($event: any) => (_ctx.handleCurrentChange('thread')))
                                }, null, 8, ["currentPage", "page-size", "total"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode("div", _hoisted_33, [
                      _createVNode(_component_el_form, {
                        class: "spacForm",
                        size: "mini",
                        model: _ctx.filterList,
                        inline: true
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "对比时间" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.filterList.old_date,
                                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_ctx.filterList.old_date = $event)),
                                onChange: _cache[40] || (_cache[40] = ($event: any) => (_ctx.compareChange('course', true)))
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateOptionsOld, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.date,
                                      label: item.date,
                                      value: item.date
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "对比版本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.filterList.old_Journa,
                                "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.filterList.old_Journa = $event))
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.JournaOptionsOld, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.time,
                                      value: item.id_test
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, null, {
                            default: _withId(() => [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.compareChange('course', false)))
                              }, {
                                default: _withId(() => [
                                  _hoisted_34
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"]),
                      _hoisted_35,
                      _withDirectives(_createVNode(_component_el_table, {
                        class: "spacName",
                        data: 
                  _ctx.courseCompare?.slice(
                    (_ctx.courseCompareCurrentPage - 1) * _ctx.courseCompareSize,
                    _ctx.courseCompareCurrentPage * _ctx.courseCompareSize
                  )
                ,
                        border: "",
                        "header-cell-style": {
                  background: '#f5f7fa',
                }
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "id",
                            label: "Id",
                            width: "200",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "name",
                            label: "Name",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "Percentage",
                            align: "center"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, {
                                prop: "percent_new",
                                label: "本次",
                                align: "center"
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "percent_old",
                                label: "对比",
                                align: "center"
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "percent_trend",
                                label: "趋势",
                                align: "center"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", {
                                    style: 
                          'color:' +
                          _ctx.getColor(
                            _ctx.getNum(scope.row.percent_new, scope.row.percent_old)
                          )
                        
                                  }, _toDisplayString(scope.row.percent_trend), 5)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "Cost(ms)",
                            align: "center"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, {
                                prop: "cost_new",
                                label: "本次",
                                align: "center"
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "cost_old",
                                label: "对比",
                                align: "center"
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "cost_trend",
                                label: "趋势",
                                align: "center"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", null, _toDisplayString(_ctx.getNum(scope.row.cost_new, scope.row.cost_old)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]), [
                        [_directive_loading, _ctx.courseCompareLoading]
                      ]),
                      _createVNode("div", _hoisted_36, [
                        _createVNode(_component_el_form, {
                          style: {"display":"flex","align-items":"center"},
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "每页"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.courseCompareSize,
                                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.courseCompareSize = $event)),
                                  style: {"width":"55px","height":"28px"},
                                  onChange: _cache[44] || (_cache[44] = ($event: any) => (_ctx.onSearch('courseCompare')))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "条记录"
                            }),
                            _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                              default: _withId(() => [
                                _createVNode(_component_el_pagination, {
                                  style: {"text-align":"right"},
                                  currentPage: _ctx.courseCompareCurrentPage,
                                  "onUpdate:currentPage": _cache[45] || (_cache[45] = ($event: any) => (_ctx.courseCompareCurrentPage = $event)),
                                  "page-size": _ctx.courseCompareSize,
                                  total: _ctx.courseCompare?.length,
                                  layout: "total, prev, pager, next,jumper",
                                  onCurrentChange: _cache[46] || (_cache[46] = ($event: any) => (_ctx.handleCurrentChange('courseCompare')))
                                }, null, 8, ["currentPage", "page-size", "total"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createVNode("div", _hoisted_39, [
                      _createVNode(_component_el_form, {
                        class: "spacForm",
                        size: "mini",
                        model: _ctx.filterList,
                        inline: true
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "对比时间" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.filterList.old_thread_date,
                                "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.filterList.old_thread_date = $event)),
                                onChange: _cache[48] || (_cache[48] = ($event: any) => (_ctx.compareChange('thread', true)))
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateOptionsOld, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.date,
                                      label: item.date,
                                      value: item.date
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "对比版本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.filterList.old_thread_Journa,
                                "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (_ctx.filterList.old_thread_Journa = $event))
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.JournaOptionsThreadOld, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.time,
                                      value: item.id_test
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, null, {
                            default: _withId(() => [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.compareChange('thread', false)))
                              }, {
                                default: _withId(() => [
                                  _hoisted_40
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"]),
                      _hoisted_41,
                      _withDirectives(_createVNode(_component_el_table, {
                        class: "spacName",
                        data: 
                  _ctx.threadCompare?.slice(
                    (_ctx.threadCompareCurrentPage - 1) * _ctx.threadCompareSize,
                    _ctx.threadCompareCurrentPage * _ctx.threadCompareSize
                  )
                ,
                        border: "",
                        "header-cell-style": {
                  background: '#f5f7fa',
                }
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "id",
                            label: "Id",
                            width: "200",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "name",
                            label: "Name",
                            align: "center"
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "Percentage",
                            align: "center"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, {
                                prop: "percent_new",
                                label: "本次",
                                align: "center"
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "percent_old",
                                label: "对比",
                                align: "center"
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "percent_trend",
                                label: "趋势",
                                align: "center"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", {
                                    style: 
                          'color:' +
                          _ctx.getColor(
                            _ctx.getNum(scope.row.percent_new, scope.row.percent_old)
                          )
                        
                                  }, _toDisplayString(scope.row.percent_trend), 5)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "Cost(ms)",
                            align: "center"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, {
                                prop: "cost_new",
                                label: "本次",
                                align: "center"
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "cost_old",
                                label: "对比",
                                align: "center"
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "cost_trend",
                                label: "趋势",
                                align: "center"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode("span", null, _toDisplayString(_ctx.getNum(scope.row.cost_new, scope.row.cost_old)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]), [
                        [_directive_loading, _ctx.threadCompareLoading]
                      ]),
                      _createVNode("div", _hoisted_42, [
                        _createVNode(_component_el_form, {
                          style: {"display":"flex","align-items":"center"},
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "每页"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.threadCompareSize,
                                  "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.threadCompareSize = $event)),
                                  style: {"width":"55px","height":"28px"},
                                  onChange: _cache[52] || (_cache[52] = ($event: any) => (_ctx.onSearch('threadCompare')))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "条记录"
                            }),
                            _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                              default: _withId(() => [
                                _createVNode(_component_el_pagination, {
                                  style: {"text-align":"right"},
                                  currentPage: _ctx.threadCompareCurrentPage,
                                  "onUpdate:currentPage": _cache[53] || (_cache[53] = ($event: any) => (_ctx.threadCompareCurrentPage = $event)),
                                  "page-size": _ctx.threadCompareSize,
                                  total: _ctx.threadCompare?.length,
                                  layout: "total, prev, pager, next,jumper",
                                  onCurrentChange: _cache[54] || (_cache[54] = ($event: any) => (_ctx.handleCurrentChange('threadCompare')))
                                }, null, 8, ["currentPage", "page-size", "total"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})